import React from "react";
import { Link } from "@quintype/components";
import { object, bool, string } from "prop-types";
import get from "lodash/get";
import { connect } from "react-redux";

import Headline from "../../atoms/Headline";

import "./storytitleInfo.m.css";

const StoryTitleInfo = ({
  story,
  iconLiveBlog,
  summary,
  publisherAttributes,
}) => {
  const isClosed = get(story, ["metadata", "is-closed"], false);
  const subHeadlineStyle = `${publisherAttributes.lang}-sub-headline`;
  
  return (
    <div styleName="wrapper" data-testid="section" className="story-title-info">
      {iconLiveBlog && !isClosed && <span styleName="live-text" />}
      <div styleName="sub-headline-entity-section-wrapper" className="print-entity-section-wrapper">
        {story.subheadline && (
          <Headline
            text={story.subheadline}
            headlineType={16}
            headerLevel={2}
            className={`section-name ${iconLiveBlog ? "live-blog-section-name" : ""}`}
            styleName={subHeadlineStyle}
          />
        )}
      </div>
      <div>
        <Headline
          text={story.headline}
          headlineType={9}
          headerLevel={1}
          className={`story-headline ${publisherAttributes.lang}-story-headline`}
        />
      </div>
      {summary && <div dangerouslySetInnerHTML={{ __html: summary }} styleName="summary" />}
    </div>
  );
};

StoryTitleInfo.propTypes = {
  story: object.isRequired,
  iconLiveBlog: bool,
  summary: string,
  publisherAttributes: object,
};

const mapStateToProps = (state) => ({
  publisherAttributes: get(state, ["qt", "config", "publisher-attributes"], {}),
});

export default connect(mapStateToProps, null)(StoryTitleInfo);
